import { combineReducers } from 'redux';
import dkwReducer from './dkwReducer';
import topHospitalsReducer from './topHospitalsReducer';

export default combineReducers({
  dkw: dkwReducer,
  topHospitals: topHospitalsReducer
});
